// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useState } from 'react'
import { InputText } from 'ui_kit_qmd'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const ProviderSearchInput = ({ value, onChange }) => {
  const [isResetClicked, setIsResetClicked] = useState(false)

  const handleClearInput = () => {
    setIsResetClicked(true)
    onChange('')
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const handleChange = (newValue) => {
    setIsResetClicked(false)
    onChange(newValue)
  }

  return (
    <InputText
      containerStyle={{ width: '601px' }}
      label='Provider name'
      value={value}
      setValue={handleChange}
      placeholder='Search provider'
      isWithClearIcon={!!value}
      onClickClear={handleClearInput}
      isResetClicked={isResetClicked}
    />
  )
}
